module.exports = __webpack_public_path__ + "img/mapIcon.1cb4a1a3.svg";